import { Reveal } from "@/components/motion";

export default function Statement() {
  return (
    <section className="bg-white text-ink sec" data-testid="statement-section">
      <div className="wrap max-w-3xl">
        <Reveal>
          <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.08]" data-testid="statement-headline">
            ESG and sustainability are more than reporting.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="h-px w-24 bg-gold my-9" aria-hidden="true" />
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-ink/70 text-[16.5px] sm:text-lg leading-relaxed max-w-2xl" data-testid="statement-copy">
            It is about understanding risk, creating resilience, improving decisions and building long-term value.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
